import { getFullUrl } from 'hubspot-url-utils';
import { BaseApp } from 'marketplace-storefront-base/containers/BaseApp';
import { sanitizeUrlPathname, sanitizeUrlSearch } from 'marketplace-storefront-base/utils/sanitizeUrlSlug';
import { getPublicRootUrl, getShortlinkUrl } from 'marketplace-storefront-base/utils/urls';
import MarketingNav from 'marketplace-ui-common/components/MarketingNav';
import { useEffect, useMemo, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
function getLoginUrl(location) {
  const {
    pathname,
    search
  } = location;
  const sanitizedPathname = sanitizeUrlPathname(pathname) || '/';
  const sanitizedSearch = sanitizeUrlSearch(search);
  return `${getFullUrl('app')}${getShortlinkUrl()}${sanitizedPathname}${sanitizedSearch}`;
}
export function PublicApp({
  history
}) {
  const [location, setLocation] = useState(history.location);
  const marketingNavLocation = useMemo(() => {
    const sanitizedPathname = sanitizeUrlPathname(location.pathname) || '/';
    const sanitizedSearch = sanitizeUrlSearch(location.search);
    return {
      pathname: `${getPublicRootUrl()}${sanitizedPathname}`,
      search: sanitizedSearch
    };
  }, [location.pathname, location.search]);
  useEffect(() => {
    const unlisten = history.listen(nextLocation => {
      setLocation(nextLocation);
    });
    return () => {
      unlisten();
    };
  }, [history]);
  return /*#__PURE__*/_jsx(MarketingNav, {
    location: marketingNavLocation,
    loginUrl: getLoginUrl(location),
    children: /*#__PURE__*/_jsx(BaseApp, {
      appContext: "public",
      history: history
    })
  });
}